import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incidents-reporting-xml-template';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentsReportingXmlTemplateEffects {

    IncidentsReportingXmlTemplate$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENTS_REPORTING_XML_TEMPLATE),
        mergeMap((x: ac.GetIncidentsReportingXmlTemplateAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentsReportingXmlTemplate().pipe(
                map((result: any) => {
                    return new ac.GetIncidentsReportingXmlTemplateErfolgreichAction(optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentsReportingXmlTemplateFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsReportingTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsReportingTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsReportingTemplatesService);
        }
        return this.service;
    }
}
